import { Spinner, makeStyles } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    width: "100%",
    minHeight: "200px",
  },
});

export function LoadingFallback() {
  const { t } = useTranslation();
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <Spinner size="large" label={t("loading")} />
    </div>
  );
}
